import React from 'react';

import { OptimizelyProvider as Provider } from '@optimizely/react-sdk';

import environmentStore from 'src/stores/EnvironmentStore';
import { getOptimizelyClient } from './sdk';

interface OptimizelyProviderProps {
  children: React.ReactNode;
}

export const OptimizelyProvider = ({ children }: OptimizelyProviderProps) => {
  const optimizely = getOptimizelyClient();
  const optimizelyState = environmentStore.optimizelyState;

  if (!optimizelyState) {
    return children;
  }

  return (
    <Provider optimizely={optimizely} user={optimizelyState.user}>
      {children}
    </Provider>
  );
};
